import * as React from "react";
import GraphiQL from "graphiql";
import * as fetch from "isomorphic-fetch";

import oktaClient from "app/utils/oktaClient";

import "./graphiql.css";

export default class CustomGraphiQL extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.graphQLFetcher = this.graphQLFetcher.bind(this);
  }

  graphQLFetcher(graphiQLParams: any) {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", oktaClient.getAuthorizationHeader());
    myHeaders.append("Content-Type", "application/json");
    const graphUrl: string =
      process.env["REACT_APP_" + process.env.REACT_APP_ENV + "_LINK"] +
      "/integration/console/graph/queries";
    return fetch(graphUrl, {
      method: "post",
      headers: myHeaders,
      body: JSON.stringify(graphiQLParams)
    }).then(response => response.json());
  }

  render() {
    return (
      <div>
        <GraphiQL fetcher={this.graphQLFetcher} />
      </div>
    );
  }
}
